export default "__VITE_ASSET__cec2749c__"